/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from "@material-ui/core/TextField";
import Autocomplete from '@material-ui/lab/Autocomplete';


import _ from 'lodash';

// import styles 
import styles from './CustomSingleSelectComboBox.css';
import CommonStyles from '../../CommonStyles.css';

// custom wrapper styles
const useStyles = makeStyles(theme => ({
  // base style of Component
  textField: {
    '& .MuiInputBase-input': {
      height: '4px',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        backgroundColor: 'transparent',
        boxShadow: '#1976d2 0 0 2px 0px',
        border: '1px solid #1976d2',
      },
    },
  }
}));

/** MaterialUI component - Select
 * Using wrapper style and custom props / function
 * Use for Text / Number / Tel / wrapper mask 
 * Props /use 
    label - label annotation 
    labelHelperText - extra helper label, render with a new line
    mandatory - required property,
    variant -  materialUI defined variant,
    selectedValue - selected value
    placeholder,
    disabled,
    onChange - input on change fn,
    menuItems - options
    valueKey - key to use for value,
    labelKeys - arrays of key to use for display item label,
    labelDisplayPrefix - used for display text prefix
    labelDisplaySeparator - used for label text separator
    stateKey - key name reference to update the sate in component
    validateForm - function callback to check / update component form state
    isHidden - To hide the Select field from UI 
 * */
const CustomSingleSelectComboBox = props => {
  const classes = useStyles();
  const [mandatoryError, setMandatoryError] = useState(false);
  const MANDATORY_TEXT = 'Required';
  const {
    label = '',
    labelHelperText = '',
    placeholder = '',
    mandatory = false,
    disabled = false,
    variant,
    selectedValue = {},
    handleChange,
    menuItems = [],
    valueKey,
    labelKeys,
    labelDisplayPrefix,
    labelDisplaySeparator,
    stateKey,
    validateForm,
    isHidden = false,
  } = props;

  // callback set component's form state
  const componentValidate = (state) => {
    if (validateForm !== undefined) {
      validateForm(state)
    }
  }

  // return display text with passed keys
  const getDisplayText = (option, keys) => {
    // check if only 1 key
    let displayText = '';
    if (keys.length === 1) {
      // this condition will not have labelDisplaySeparator
      return displayText = labelDisplayPrefix !== undefined ? `${labelDisplayPrefix} ${option[keys[0]]}` : `${option[keys[0]]}`;
    } else {
      let displayText = labelDisplayPrefix !== undefined ? `${labelDisplayPrefix} ` : '';
      keys.forEach((element, index) => {
        // passed labelDisplayPrefix, need to have prefix but ignore Separator
        if (labelDisplayPrefix && index === 0) {
          displayText = `${displayText} ${option[element]}`
        } else {
          // this condition will be when Separator is there, should be only with more then 1keys
          if (labelDisplaySeparator !== undefined) {
            displayText = `${displayText}${index === 0 ? '' : labelDisplaySeparator} ${option[element]}`
          } else {
            displayText = `${displayText} ${option[element]}`;
          }
        }
      });
      return displayText;
    }
  }

  // check if value changed, do the validation
  // covers manual(Programmatically) state change, which are not input changes 
  useEffect(() => {
    // show if field is empty
    if (mandatory && _.isEmpty(selectedValue)) {
      // setMandatoryError(true);
      componentValidate(true)
    } else if (mandatory && !_.isEmpty(selectedValue)) {
      setMandatoryError(false);
      componentValidate(false)
    }
  }, [selectedValue])

  return <React.Fragment>
    <InputLabel shrink className={styles.label}>
      <label className={CommonStyles.label}>
        {label}
       </label>
      {mandatory &&
        <label className={CommonStyles.asterisk}>&#x2a;
        </label>
      }
    </InputLabel>
    <Autocomplete
      disablePortal
      id={label}
      hidden={isHidden}
      getOptionLabel={(option) => getDisplayText(option, labelKeys)}
      options={menuItems}
      value={_.isEmpty(selectedValue) ? null : selectedValue}
      sx={{ width: '100%' }}
      disabled={disabled}
      onChange={(e, val) => handleChange(e, stateKey, val)}
      // To show required/error only when field is visited at least once
      onBlur={() => {
        if(mandatory && _.isEmpty(selectedValue)){
          setMandatoryError(true);
        }
      }}
      renderInput={(params) => <TextField
        {...params}
        className={classes.textField}
        error={mandatoryError}
        helperText={mandatoryError && MANDATORY_TEXT}
        variant={variant}
        placeholder={placeholder}
      />}
    />
  </React.Fragment>
}

export default CustomSingleSelectComboBox;


// WEBPACK FOOTER //
// ./src/views/components/Common/FormMUIWrapperComponents/CustomSingleSelectComboBox/CustomSingleSelectComboBox.jsx